export default __webpack_public_path__ + "static/media/cards-organic@3x.0e802ba2.png";